<template>
  <header
    id="obituary-header"
    :style="headerStyle"
    :class="{
      noImg: noImage,
      noSkinBanner: !skinBanner || (skinBanner && !skinBanner.backImg)
    }"
  >
    <!-- logo -->
    <div class="logoimg" v-if="skinBanner && skinBanner.logoImg">
      <img :src="skinBanner.logoImg.filePath" />
    </div>

    <div class="photo-area" :class="{ noImg: noImage }">
      <p v-if="!skinBanner.backImg">訃告</p>
      <p v-else-if="!showCondolenceText"></p>
      <p v-else>삼가 고인의 명복을 빕니다</p>
      <div v-if="showDeceasedImage" class="deceased-img__box">
        <img
          class="deceased-img"
          alt=""
          :src="obituaryDetail.Files[0].filePath"
        />
        <img
          v-if="showFlowerImage"
          class="deco-img"
          src="@/assets/images/obituary/flower_1.svg"
          alt=""
        />
      </div>
    </div>

    <div class="deceased-info">
      <h4 v-if="showBasicNameInfo">
        故 {{ obituaryDetail ? obituaryDetail.name : "" }}{{ obituaryDetail.subname ? "(" + obituaryDetail.subname + ")" : "" }}
      </h4>
      <h4 v-else style="display: flex;flex-direction: column;text-align: center;">
        故 {{ obituaryDetail ? obituaryDetail.name : "" }}{{ obituaryDetail.subname ? "(" + obituaryDetail.subname + ")" : "" }}
        <span>
          (
          <span
            v-if="
              obituaryDetail && !obituaryDetail.ageDisable && obituaryDetail.age
            "
          >
            {{ obituaryDetail.age }}세
          </span>
          <span
            v-if="
              obituaryDetail &&
                !obituaryDetail.ageDisable &&
                obituaryDetail.age &&
                !obituaryDetail.genderDisable &&
                obituaryDetail.gender
            "
            >/
          </span>
          <span
            v-if="
              obituaryDetail &&
                !obituaryDetail.genderDisable &&
                obituaryDetail.gender
            "
            >{{ gender }}</span
          >
          )
        </span>
      </h4>

      <p v-if="showDieDate">
        {{
          PRINTYYMMDDDate(obituaryDetail.dieDate) + " " + obituaryDetail.dieType
        }}
      </p>
    </div>
  </header>
</template>

<script>
export default {
  name: "ObituaryHeader",
  props: ["obituaryDetail", "skinBanner"],

  computed: {
    headerStyle() {
      return {
        backgroundColor: this.skinBanner?.backgroundColor ?? null,
        backgroundImage: this.skinBanner?.backImg
          ? `url(${this.skinBanner.backImg.filePath})`
          : null
      };
    },

    noImage() {
      return (
        this.obituaryDetail &&
        (!this.obituaryDetail.pictureYn ||
          this.obituaryDetail.Files.length === 0)
      );
    },

    showCondolenceText() {
      return (
        !(this.skinBanner && !this.skinBanner.textUseYn) &&
        !(this.obituaryDetail && this.obituaryDetail.eventNo)
      );
    },
    showDeceasedImage() {
      return (
        this.obituaryDetail &&
        this.obituaryDetail.pictureYn &&
        this.obituaryDetail.Files.length > 0
      );
    },
    showFlowerImage() {
      return (
        this.skinBanner &&
        this.skinBanner.flowerUseYn &&
        !(this.obituaryDetail && this.obituaryDetail.eventNo)
      );
    },

    showBasicNameInfo() {
      return (
        (this.obituaryDetail?.genderDisable &&
          this.obituaryDetail?.ageDisable) ||
        (!this.obituaryDetail?.age && !this.obituaryDetail?.gender)
      );
    },
    showDieDate() {
      return this.obituaryDetail?.eventNo && this.obituaryDetail?.dieDateYn;
    },

    gender() {
      switch (this.obituaryDetail && this.obituaryDetail.gender) {
        case "M":
          return "남";

        case "W":
          return "여";

        default:
          return this.obituaryDetail?.gender;
      }
    }
  }
};
</script>

<style></style>
